import { call, put, takeLatest } from 'redux-saga/effects';
import { getProjects, updateProject } from 'api/ProjectsAPI';
import { getErrorResponse } from 'utils/xhr';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import type { Project } from './types';

/**
 * fetchProjectsSaga
 * Saga for fetching projects
 */
export function* fetchProjectsSaga() {
  try {
    const data: Project[] = yield call(getProjects);
    yield put(actions.fetchProjectsResponse(data));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.fetchProjectsError(err));
    const message = `Please try again later. If the problem persists, contact your CSM.`;
    yield put(addNegativeToast(message));
  }
}

/**
 * updateProjectSaga
 * Saga for updating project
 */
export function* updateProjectSaga({ project }: ReturnType<typeof actions.updateProjectRequest>) {
  try {
    yield call(updateProject, project);
    yield put(actions.updateProjectResponse(project));
    yield put(addPositiveToast('Successfully updated project.'));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.updateProjectError(err));
    const message = `Please try again later. If the problem persists, contact your CSM.`;
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([
  takeLatest(
    [actionTypes.FETCH_PROJECTS_REQUEST, actionTypes.UPDATE_PROJECT_RESPONSE],
    fetchProjectsSaga,
  ),
  takeLatest(actionTypes.UPDATE_PROJECT_REQUEST, updateProjectSaga),
]);
